<template>
    <div>
      <!-- Botón de hamburguesa -->
      <button
        @click="toggleMenu"
        class="fixed top-4 left-4 z-50 bg-gray-800 text-white p-2 rounded focus:outline-none focus:ring"
      >
        <i class="fas fa-bars"></i>
      </button>
  
      <!-- Menú lateral -->
      <aside
        :class="{
          'translate-x-0': menuVisible,
          '-translate-x-full': !menuVisible,
        }"
        class="fixed top-0 left-0 h-full w-64 bg-gray-800 text-white shadow-lg transform transition-transform duration-300 z-40"
      >
        <ul class="p-4 space-y-4 pt-20">
          <li>
            <router-link
              to="/dashboard"
              class="text-white hover:underline"
              @click="closeMenu"
            >
              Inicio
            </router-link>
          </li>
          <li>
            <router-link
              to="/dashboard/claves-pendientes"
              class="text-white hover:underline"
              @click="closeMenu"
            >
              Claves pendientes
            </router-link>
          </li>
          <li>
            <router-link
              to="/dashboard/claves-finales"
              class="text-white hover:underline"
              @click="closeMenu"
            >
              Claves finales
            </router-link>
          </li>
          <li>
            <router-link
              to="/dashboard/gestion-premios"
              class="text-white hover:underline"
              @click="closeMenu"
            >
              Gestión de premios
            </router-link>
          </li>
          <li>
            <router-link
              to="/dashboard/buscar-premio"
              class="text-white hover:underline"
              @click="closeMenu"
            >
              Validar premios
            </router-link>
          </li>
          <li>
            <!-- Enlace para cerrar sesión -->
            <button
              @click="handleLogout"
              class="text-white hover:underline w-full text-left"
            >
              Cerrar sesión
            </button>
          </li>
        </ul>
      </aside>
  
      <!-- Overlay para cerrar el menú -->
      <div
        v-if="menuVisible"
        class="fixed inset-0 bg-black bg-opacity-50 z-30"
        @click="toggleMenu"
      ></div>
    </div>
  </template>
  
  <script>
  import { mapActions } from "vuex";
  
  export default {
    data() {
      return {
        menuVisible: false,
      };
    },
    methods: {
      toggleMenu() {
        this.menuVisible = !this.menuVisible;
      },
      closeMenu() {
        this.menuVisible = false;
      },
      ...mapActions(["logout"]),
      handleLogout() {
        this.logout(); // Llama a la acción de Vuex
        this.$router.push("/login"); // Redirige al usuario al inicio de sesión
      },
    },
  };
  </script>
  
  <style scoped>
  /* No se requieren estilos adicionales ya que usamos exclusivamente TailwindCSS */
  </style>
  